export default "__VITE_ASSET__BS5V9r9w__"